// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__PkKlh","error":"Checkbox_error__FKhCQ"};